import { ActionType } from "./actions";

const defaultState = {
  MessageList:{},
  ChatList:[]
};

export const reducer = (state = defaultState, action) => {

  switch (action?.type) {
    case ActionType?.SET_STORE_MESSAGE_RECEIVED:
      return {
        ...state,
        ChatList:action?.payload?.messages,
      };
    case ActionType?.SET_STORE_MESSAGE:
      const Message = state?.ChatList
        Message?.push(action?.payload?.message)
      return {
        ...state,
        ChatList:Message,
      };
    case ActionType?.ADD_CHAT_MESSAGE:
      console.log("ADD_CHAT_MESSAGE", action, state?.ChatList)
      const ChatMessage = state?.ChatList;
      ChatMessage?.push(action?.payload)
      return {
        ...state,
        ChatList: ChatMessage,
      };
    default:
      return state;
  }
};

export default reducer;
